import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus, MessageCircle } from "lucide-react";
import { FAQS, PROFILE } from "@/data";
import { Reveal, SectionHeading } from "@/components/Reveal";

export default function Faq() {
  const [open, setOpen] = useState(0);

  return (
    <section id="faq" data-testid="faq-section" className="relative py-24 sm:py-32">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionHeading id="faq" overline="FAQ" title="Questions, answered upfront" />
        <div className="space-y-3">
          {FAQS.map((f, i) => {
            const isOpen = open === i;
            return (
              <Reveal key={i} delay={i * 0.05}>
                <div
                  data-testid={`faq-item-${i}`}
                  className={`rounded-2xl border transition-colors duration-500 overflow-hidden ${
                    isOpen ? "border-[#D9A441]/40 bg-[#101F38]" : "border-white/10 bg-[#101F38]/50 hover:border-white/25"
                  }`}
                >
                  <button
                    onClick={() => setOpen(isOpen ? -1 : i)}
                    data-testid={`faq-toggle-${i}`}
                    className="w-full flex items-center justify-between gap-6 p-6 text-left"
                  >
                    <span className="font-display text-lg sm:text-xl font-semibold text-[#F3EFE6]">{f.q}</span>
                    <motion.span
                      animate={{ rotate: isOpen ? 45 : 0 }}
                      transition={{ duration: 0.3 }}
                      className={`flex-shrink-0 ${isOpen ? "text-[#D9A441]" : "text-[#9DAEC4]"}`}
                    >
                      <Plus size={20} />
                    </motion.span>
                  </button>
                  <AnimatePresence initial={false}>
                    {isOpen && (
                      <motion.div
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: "auto", opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
                      >
                        <p className="px-6 pb-6 text-[#9DAEC4] leading-relaxed" data-testid={`faq-answer-${i}`}>
                          {f.a}
                        </p>
                      </motion.div>
                    )}
                  </AnimatePresence>
                </div>
              </Reveal>
            );
          })}
        </div>
        <Reveal delay={0.2}>
          <p className="mt-10 text-center text-sm text-[#9DAEC4]">
            Still curious?{" "}
            <a
              href={PROFILE.whatsapp}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="faq-whatsapp-link"
              className="inline-flex items-center gap-1.5 text-[#D9A441] hover:text-[#E5B85C] font-semibold transition-colors"
            >
              <MessageCircle size={14} />
              Ask directly on WhatsApp
            </a>
          </p>
        </Reveal>
      </div>
    </section>
  );
}
